import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedSourceDataAtom } from '../../../atoms/selectedSourceData';
import { getUploadMethods } from '../sourceOptions';

const byPreventManualSelection = (option) => !option.preventManualSelection;

export function SelectUploadMethod({ size }) {
  const intl = useIntl();
  const [sourceData, setSourceData] = useAtom(selectedSourceDataAtom);
  const handleUploadMethodChange = (option) => {
    setSourceData({
      ...sourceData,
      requiresTranscoding: option.requiresTranscoding,
      uploadMethod: option.id,
    });
  };

  return (
    <Dropdown
      id="display-provide-upload-method"
      label={intl.formatMessage({
        defaultMessage: 'Upload Method',
        id: '6ff6e',
      })}
      labelPosition="top"
      onChange={(selectedOption) =>
        handleUploadMethodChange(selectedOption.value)
      }
      options={getUploadMethods(intl).filter(byPreventManualSelection)}
      size={size}
      title={intl.formatMessage({
        defaultMessage: 'Upload Method',
        id: '6ff6e',
      })}
      value={getUploadMethods(intl).find(
        (option) => option.value.id === sourceData?.uploadMethod,
      )}
      variant="secondary"
    />
  );
}
SelectUploadMethod.propTypes = { size: PropTypes.string };
SelectUploadMethod.defaultProps = { size: undefined };

export default { SelectUploadMethod };
